import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import Grid2 from "@mui/material/Grid2";
import { createStyles, makeStyles } from "@mui/styles";
import type { EditableCallbackParams } from "ag-grid-community";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) =>
	createStyles({
		assetLink: {
			color: theme.palette.primary.main,
			cursor: "pointer",
			textDecoration: "none",
			"&:hover": {
				textDecoration: "underline",
			},
		},
	}),
);

type Props = EditableCallbackParams;

const getCompactPath = (fullPath: string) => {
	if (!fullPath) return "";
	const parts = fullPath.split("/");
	if (parts.length <= 3) return fullPath;
	return `${parts[0]}/.../${parts[parts.length - 2]}/${parts[parts.length - 1]}`;
};

export const PartAssetNameColumn = ({ data }: Props) => {
	const classes = useStyles();
	const navigate = useNavigate();
	const {
		state: { assetFullPath, currentGridName, assetSearchId },
	} = useAssetDetailsContext();

	const handleAssetClick = (assetId: string | number) => {
		navigate(
			`/asset-details/${assetId}?resource=${currentGridName}&assets=true&statistics=true&workOrders=true`,
		);
	};

	if (data?.id === -1) {
		return (
			<Grid2
				container
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid2 style={{ alignItems: "center", justifyContent: "center" }}>
					{getCompactPath(assetFullPath as string)}
				</Grid2>
			</Grid2>
		);
	} else if (data?.id !== -1 && data?.AssetId) {
		const compactPath = getCompactPath(data?.FullPath || "");
		const isCurrentAsset =
			data.AssetId.toString() === assetSearchId?.toString();

		if (isCurrentAsset) {
			return <div title={data?.FullPath}>{compactPath || data?.AssetName}</div>;
		} else {
			return (
				<div
					title={data?.FullPath}
					className={classes.assetLink}
					onClick={() => handleAssetClick(data.AssetId)}
				>
					{compactPath || data?.AssetName}
				</div>
			);
		}
	} else if (data?.id !== -1) {
		return <div title={data?.FullPath}>{data?.AssetName}</div>;
	} else return <></>;
};
